<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${resellerPayment.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="resellerPayment" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "reseller-payment-view-logs",

  components: { LogListTable },

  props: ["resellerPayment"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
